import * as actions from "Actions";
import * as api from "Api";

export const fetchCategories = dir => (dispatch, getState) => {
  const { lng } = getState().params;
  const { auth } = getState();
  const { token, navCommunity } = auth;
  if (token === "") {
    return api.getClientCredential().done(resp => {
      const help = typeof resp === "string" ? JSON.parse(resp) : resp;
      const clientToken = help.token.access_token;
      dispatch(actions.setAuthToken(clientToken));
      return dispatch(
        actions.fetchCategories(
          api.getCategories({
            token: clientToken,
            lng,
            dir,
            community: navCommunity ? navCommunity : null
          })
        )
      );
    });
  }
  return dispatch(
    actions.fetchCategories(
      api.getCategories({
        token,
        lng,
        dir,
        community: navCommunity ? navCommunity : null
      })
    )
  );
};

export const saveCategory = ({
  id,
  titleFR,
  titleEN,
  titleNL,
  descriptionFR,
  descriptionEN,
  descriptionNL,
  color,
  isPersonal,
  mediaIds
} = {}) => (dispatch, getState) => {
  const { token, navCommunity } = getState().auth;
  const { lng } = getState().params;

  return dispatch(
    actions.saveCategory(
      api.saveCategory({
        token,
        lng,
        id,
        community: navCommunity,
        titleFR,
        titleEN,
        titleNL,
        descriptionFR,
        descriptionEN,
        descriptionNL,
        color,
        isPersonal,
        mediaIds
      })
    )
  );
};



// WEBPACK FOOTER //
// ./src/actions/thunks/category.js